import { FC, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getProjectLlmInfo } from 'src/api/projects';
import { getProject } from 'src/redux/projects/selectors';
import { RoutesEnum } from 'src/types/navigation';
import LlmInfoView from './components/LlmInfoView';

type Params = { id: string };

const ProjectLlmInfoPage: FC = () => {
    const { id } = useParams<Params>();
    const project = useSelector(getProject(id ?? null));
    const fetchSessions = useCallback(
        () => (id ? getProjectLlmInfo(id) : Promise.resolve({ data: [] })),
        [id]
    );

    const title = project.projectName
        ? `LLM Info for ${project.projectName}`
        : `LLM Info for project ${id ?? ''}`;

    return (
        <LlmInfoView
            title={title}
            backTo={RoutesEnum.PROJECT_DASHBOARD}
            fetchSessions={fetchSessions}
        />
    );
};

export default ProjectLlmInfoPage;
